// extracted by mini-css-extract-plugin
module.exports = {"categoryMenu":"style_categoryMenu__e7ifz","dispenser":"style_dispenser__WG_9m","arrowRight":"style_arrowRight__7Zwnb"};